import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import UtilPG from '@/assets/ts/utils/Util';
import { OcorrenciaController } from '@/assets/ts/controller/OcorrenciaController';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import store from '@/store/store';

@Component({
  name: 'ApuraAutoAdcNoturnoPopup',
  components: {
    TkForm,
  },
})
class ApuraAutoAdcNoturnoPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: null })
  private readonly nrVinculomProp: number;

  @Prop({ default: null })
  private readonly dtiniperiodo: string;

  @Prop({ default: null })
  private readonly dtfimperiodo: string;

  @Prop({ default: null })
  private readonly nrPeriodo: number;

  @Prop({ default: null })
  private readonly vinculosUnidade: any;

  @Prop({ default: null })
  private readonly nomeUnidade: string;


  @Prop({ default: [] })
  private readonly rowsProp: any;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(show: boolean) {}
  // #endregion

  // #region [ STORE ]
  private get user() {
    return this.$store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  // #endregion

  // #region [ DATA ]
  private internalValue = false;

  private loading = false;

  private loadingFile = false;
  private conformeHorarioBase = 'S';

  private vinculos: any[] = null;

  private eventos:  any[] = null;

  private resetDates = false;

  private row: any = {};

  private defaultRow = {
    __is_new: true,
  };

  // #endregion

  // #region [ COMPUTED ]
  private get genericFilter() {
    const filter = {
      NRORG: this.user.nrorg,
      CDOPERADOR: this.user.cdoperador,
    };

    return filter;
  }


  private get habilitarFiltroVinculos() {
    return this.row.IDAPURAUTOADCNOTUR == 'UNID';
  }

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRVINCULOM',
        label: 'Vínculo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRVINCULOM',
        descriptionField: 'NMVINCULOM',
        items: this.vinculos,
        required: !this.nrVinculomProp,
        isVisible: !this.nrVinculomProp
      },
      {
        name: 'IDAPURAUTOADCNOTUR',
        label: 'Apuração Automática de Adicional Noturno',
        type: 'radio',
        valueField: 'value',
        items: [
          {
            label: 'Por Unidade',
            value: 'UNID',
          },
          {
            label: 'Por Vínculo',
            value: 'VINC',
          },
        ],
        size: !this.habilitarFiltroVinculos ? 12 : 6,
        isVisible: true,
        required: true,
      },
      {
        name: 'IDSTATUSVINCULO',
        label: 'Vínculos',
        type: 'radio',
        valueField: 'value',
        items: [
          {
            label: 'Ativos',
            value: 'A',
          },
          {
            label: 'Rescindidos',
            value: 'R',
          },
          {
            label: 'Todos',
            value: 'T',
          },

        ],
        size: 6,
        isVisible: this.habilitarFiltroVinculos,
        required: true,
      },
      {
        name: 'DTINICIOPERIODO',
        label: 'Início Período',
        size: 6,
        type: 'date',
        required: true,
        readonly: false,
        isVisible: true,
      },
      {
        name: 'DTFIMPERIODO',
        label: 'Fim Período',
        type: 'date',
        size: 6,
        readonly: false,
        required: true,
        isVisible: true,
      },
      {
        name: 'DTMESCOMPETENC',
        label: 'Data de Competência',
        type: 'date',
        size: 12,
        month: true,
        readonly: false,
        required: true,
        isVisible: true,
      },
      {
        name: 'NREVENTOM',
        label: 'Evento',
        type: 'autocomplete',
        required: true,
        valueField: 'NREVENTOM',
        descriptionField: 'NMEVENTOH',
        size: 12,
        items: this.eventos,
      },
      {
        name: 'IDCONFORMEHORARIOBASE',
        label: 'Conforme Horario Base',
        type: 'checkbox',
        size: 12,
        readonly: true,
        isVisible: true,
        valueField: '',
        valueToTrue: 'S',
        valueToFalse: 'N'
      },
    
    ];

    return fields;
  }
  // #endregion

  //#region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.row = Util.deepCopy(this.defaultRow);
      this.row.DTFIMPERIODO = this.dtfimperiodo;
      this.row.DTINICIOPERIODO = this.dtiniperiodo;
      this.row.IDCONFORMEHORARIOBASE = 'S';
      this.row.IDAPURAUTOADCNOTUR = 'UNID';

      if(this.eventos === null) {
        this.loadEventos();
      }

      if (this.vinculos === null && !this.nrVinculomProp) {
        this.reloadVinculos();
      }

    }
  }

  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.vinculos = null;
  }
  //#endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private verifyRequiredFields(): boolean {
    const isValid = this.row.__is_valid;

    if (isValid) {
      return true;
    }

    const message = 'Favor preencher todos os campos obrigatórios!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

    return false;
  }

  private async save() {
    if (!this.verifyRequiredFields()) {
      return;
    }

    await DialogUtils.show(
      'Apurar',
      'Deseja realmente realizar uma Apuracação Automática de Adicional Noturno?'
    );

    try {
      await this.apuraAutoAdicionalNoturno();
      

      this.closeDialog();
      this.emitAfterSave(); 
    } catch (error) {}
  }

  private async apuraAutoAdicionalNoturno() {
    const route = 'apurarAutoAdcNoturno';

    const params = {
      requestType: 'Row',
      NRORG: this.user.nrorg,
      row: {
        ...this.row,
        NRPERIODO: this.nrPeriodo,
        NRVINCULOM: this.nrVinculomProp,
        NRVINCULOM_LIST: this.vinculosUnidade,
        CDOPERADOR: this.user.cdoperador,
        DTFINALAPURACAO: this.periodoDemonstrativoAtual.DTFINALAPURACAO,
        NOMEUNIDADE: this.nomeUnidade,
      },
    };

    this.loading = true;

    try {

      const dtmescompetenc = this.row.DTMESCOMPETENC;
      const [dia, mes, ano] = dtmescompetenc.split('/').map(Number);
      const isPrimeiroDia = dia === 1;

      if (!isPrimeiroDia) {
        const message = 'O campo Data de Competência deve ser o primeiro dia do mês!';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
        return;
      }
      
      const response = await HttpRequest.post(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.dataset) {
        const message = 'Adicional Noturno apurado com sucesso! Lote adicionado à importação da folha.';
        SnackbarUtils.showMessage(message, 'success', 10000);
      }
    
      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

    } catch (err) {
      const defaultError = 'Erro durante a apuração do adicional noturno';
      const message = err && (err as any).response ? (err as any).response.data.error : defaultError;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR, 20000);
    } finally {
      this.loading = false;
    }
  }

  private async reloadVinculos() {
    const vinculos = await CommonRequests.getVinculosDoGestor();
    this.vinculos = vinculos;
  }


  private async loadEventos() {
    this.eventos = await OcorrenciaController.getEventosAtivos();
  }



  

  // #endregion
}

export default ApuraAutoAdcNoturnoPopup;